import { AppModule } from '@app/types';

/** Compose module: station-scoped compositions and composition-linked video edits. */
export const ComposeModule: AppModule = {
  id: 'compose',
  title: 'Compose',
  basePath: 'compose',
};
